import { render, staticRenderFns } from "./wayNumberDialog.vue?vue&type=template&id=4046f1ed"
import script from "./wayNumberDialog.vue?vue&type=script&lang=js"
export * from "./wayNumberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports